import React, {
  Component
} from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
//import { AUTH_TOKEN, USERNAME } from '../constants';
import "./styles/main.scss";
import "./scripts/main.js";
import Nav from "./partials/nav";
import Cookies from "universal-cookie";
import CookieConsent from "react-cookie-consent";
const cookies = new Cookies();

const OPTIONS_QUERY = gql`
  query MyQuery {
    themeGeneralSettings {
      optionsPage {
        fieldGroupName
        gimmeMore
        komanda
        newsletterSubscribeText
        readLess
        readMore
        singlePostShareButtonsText
        logoImage {
          mediaItemUrl
          title
        }
        mainMenu {
          title
          url
        }
        cookieTextEn
        cookieTextLv
        privacyPolicyTitleLv
        privacyPolicyTitleEn
        privacyPolicyConsentButtonTextLv
        privacyPolicyConsentButtonTextEn
        privacyPolicyFile {
          mediaItemUrl
        }
      }
    }
  }
`;

class HeaderKKC extends Component {
  state = {
    image: "",
    isActive: false
  };

  handleToggle = () => {
    this.setState({
      isActive: !this.state.isActive
    });
  };
  // componentDidMount() {
  //   this.executeOptionsPage();
  // }

  // executeOptionsPage = async () => {
  //   const { client } = this.props;
  //   const result = await client.query({
  //     query: OPTIONS_QUERY
  //   });
  //   const image =
  //     result.data.themeGeneralSettings.optionsPage.logoImage.mediaItemUrl;
  //   const title = result.data.themeGeneralSettings.optionsPage.logoImage.title;
  //   this.setState({ image, title });
  // };

  render() {
    //const { image, title } = this.state;
    const {
      data: { loading, themeGeneralSettings }
    } = this.props;

  // const [isActive, setActive] = useState(false);

  // const toggleClass = () => {
  //   setActive(!isActive);
  // };
    
    const isActive = this.state.isActive;
    
    return (
    <>
        {!loading && themeGeneralSettings && (
      <>
      <header className="banner">
        <div className="row">
          <div className="col-12 bannerCol">
            <a className="brand" href="/">
              <img src={this.props.data.themeGeneralSettings.optionsPage.logoImage.mediaItemUrl} alt={this.props.data.themeGeneralSettings.optionsPage.logoImage.title} />
            </a>

            <div className="hamburger--wrap">
              <div className="section--name"></div>

              <button className = {
              isActive ? 'hamburger hamburger--spin is-active' : 'hamburger hamburger--spin'
              } onClick={this.handleToggle}
              type = "button" >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <Nav />
            </div>
          </div>
        </div>
        </header>
        
        <CookieConsent
  location="bottom"
  buttonText={cookies.get("lang") === "LV" ?
      this.props.data.themeGeneralSettings.optionsPage.privacyPolicyConsentButtonTextLv: this.props.data.themeGeneralSettings.optionsPage.privacyPolicyConsentButtonTextEn
      }
  cookieName="kkcCookieConsent"
  style={{ background: "#2B373B" }}
  buttonStyle={{ background: "#ec7136", color: "white", fontSize: "13px" }}
  expires={150}
>
   {cookies.get("lang") === "LV" ?
      this.props.data.themeGeneralSettings.optionsPage.cookieTextLv: this.props.data.themeGeneralSettings.optionsPage.cookieTextEn
      }
  <span style={{ marginLeft:"10px",fontSize: "10px" }}><a href={this.props.data.themeGeneralSettings.optionsPage.privacyPolicyFile.mediaItemUrl} target="_blank" rel="noopener noreferrer" >{cookies.get("lang") === "LV" ?
      this.props.data.themeGeneralSettings.optionsPage.privacyPolicyTitleLv: this.props.data.themeGeneralSettings.optionsPage.privacyPolicyTitleEn
      }</a></span>
        </CookieConsent>
        </>
        )}
        </>
    );
  }
}
export default graphql(OPTIONS_QUERY)(HeaderKKC);
